import './AuthLayout.css'

/**
 * AuthLayout — shell des ecrans non authentifies (login, futur reset password).
 *
 * Centre verticalement et horizontalement une carte `ui-surface ui-surface--rule`
 * dans un viewport plein. Standardise l'eyebrow + le titre.
 *
 *   <AuthLayout eyebrow="Atelier · sgraphic" title="Portail interne">
 *     <form ...>...</form>
 *   </AuthLayout>
 */
import type { ReactNode } from 'react'

interface AuthLayoutProps {
  eyebrow?: string
  title: string
  children: ReactNode
}

export default function AuthLayout({ eyebrow, title, children }: AuthLayoutProps) {
  return (
    <main className="auth-layout">
      <section className="ui-surface ui-surface--rule auth-layout-card">
        <header className="auth-layout-header">
          {eyebrow && <p className="ui-eyebrow">{eyebrow}</p>}
          <h1 className="ui-h2 auth-layout-title">{title}</h1>
        </header>
        {children}
      </section>
    </main>
  )
}
